const comments = [
  {
    name: '光影追梦人',
    time: '2天前',
    text: '这个网站真的太棒了！91免费视频网站在线观看体验非常流畅，画质清晰不缓冲，比很多付费平台都好用，强烈推荐给喜欢看高清视频的朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20soft%20portrait%20of%20Asian%20person%20in%20casual%20setting%2C%20friendly%20expression%2C%20soft%20lighting%2C%20circular%20crop%2C%20warm%20background%20blur&width=80&height=80&seq=avatar-01&orientation=squarish',
  },
  {
    name: '剧集收藏家',
    time: '3天前',
    text: '收藏了91在线观看视频网站快一年了，资源更新速度真的快，每天都有新内容。画质选择也多，网速不好还能自动降画质，很人性化。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20soft%20portrait%20of%20person%20with%20gentle%20smile%2C%20indoor%20natural%20lighting%2C%20circular%20crop%20composition%2C%20relaxed%20vibe%2C%20warm%20neutral%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
  },
  {
    name: '深夜放映室',
    time: '5天前',
    text: '作为资深影视迷，91免费视频网站的资源库真的太全了。从经典老片到最新热播，分类清晰找起来很方便。免费视频网站在线观看就选它！',
    avatar: 'https://readdy.ai/api/search-image?query=Soft%20portrait%20of%20person%20with%20warm%20expression%2C%20evening%20ambient%20lighting%2C%20circular%20crop%2C%20cozy%20atmosphere%2C%20warm%20tone%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
  },
  {
    name: '电影搬运工',
    time: '1周前',
    text: '高清视频网站免费的真不多见，91免费视频网站不仅免费还高清，加载速度也快。我已经把它分享给身边所有喜欢看电影的朋友了！',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20person%20with%20bright%20expression%2C%20daylight%20window%20lighting%2C%20circular%20crop%2C%20warm%20natural%20tones%2C%20casual%20professional%20look&width=80&height=80&seq=avatar-04&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            用户评价
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            用户怎么说
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实用户的使用反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {comments.map((comment) => (
            <div
              key={comment.name}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="font-heading font-semibold text-sm text-foreground-900">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}